{
  "noAssignedModeling": "",
  "modelings": "",
  "pleaseSignIn": "",
  "email": "",
  "enterLogin": "",
  "signIn": "",
  "password": "",
  "enterPassword": "",
  "filterByName": "",
  "settings": "",
  "logout": "",
  "home": "",
  "users": "",
  "areas": "",
  "modelingName": "",
  "passwordChange": "",
  "close": "",
  "confirm": "",
  "userDelete": "",
  "wannaDeleteThisUser": "",
  "delete": "",
  "modelingDelete": "",
  "wannaDeleteThisModeling": "",
  "userCreation": "",
  "create": "",
  "name": "",
  "enterUserName": "",
  "loginName": "",
  "role": "",
  "chooseRole": "",
  "viewer": "",
  "admin": "",
  "team": "",
  "teamName": "",
  "group": "",
  "groups": "",
  "chooseGroup": "",
  "choose": "",
  "groupCreation": "",
  "enterGroupName": "",
  "groupDetail": "",
  "save": "",
  "userDetail": "",
  "modelingCreation": "",
  "modelingDetail": "",
  "datasetList": "",
  "assetTypeList": "",
  "activityList": "",
  "lifeCycleList": "",
  "description": "",
  "benefitList": "",
  "forecastList": "",
  "budgetList": "",
  "performanceList": "",
  "activityDelete": "",
  "wannaDeleteThisActivity": "",
  "lifeCycleDelete": "",
  "wannaDeleteThisLifeCycle": "",
  "benefitDelete": "",
  "wannaDeleteThisBenefit": "",
  "performanceDelete": "",
  "wannaDeleteThisPerformance": "",
  "unit": "",
  "unitCost": "",
  "rootActivity": "",
  "activityColor": "",
  "activityCreate": "",
  "activityDetail": "",
  "costFactor": "",
  "benefitCreate": "",
  "benefitAttributes": "",
  "weight": "",
  "biggerMoreBenefit": "",
  "mandatoryActAttr": "",
  "mandatoryActYearAttr": "",
  "performance": "",
  "performanceName": "",
  "performanceDescription": "",
  "performanceLifespan": "",
  "performanceRanges": "",
  "startTheoreticalAge": "",
  "endTheoreticalAge": "",
  "startAssetPerformance": "",
  "endAssetPerformance": "",
  "startIAPP": "",
  "endIAPP": "",
  "color": "",
  "lifeCycleActivities": "",
  "activityName": "",
  "activityUnitCost": "",
  "activityCostFactor": "",
  "minAge": "",
  "maxAge": "",
  "noAct": "",
  "significant": "",
  "effect": "",
  "changeToLifeCycleId": "",
  "notFirst": "",
  "root": "",
  "lifeCycleFilters": "",
  "sign": "",
  "number": "",
  "lifeCycleCreate": "",
  "lifeCycleDetail": "",
  "activity": "",
  "datasetDetail": "",
  "addAssetType": "",
  "addPerformance": "",
  "addBenefit": "",
  "addLifeCycle": "",
  "addDataset": "",
  "addBudget": "",
  "addForecast": "",
  "addActivity": "",
  "addCostFactor": "",
  "inputModel": "",
  "analysis": "",
  "results": "",
  "datasetCreate": "",
  "assetTypeDetail": "",
  "forecastCreate": "",
  "assetTypeCreate": "",
  "budgetCreate": "",
  "budgetDetail": "",
  "performanceCreate": "",
  "performanceDetail": "",
  "select": "",
  "signif": "",
  "changeToLifeCycle": "",
  "benefitDetail": "",
  "back": "",
  "assetType": "",
  "incorrectUserOrPassword": "",
  "startYear": "",
  "endYear": "",
  "inflationRate": "",
  "discountRate": "",
  "forecastAssetTypes": "",
  "assetTypes": "",
  "assetAttr": "",
  "ageAttr": "",
  "dataset": "",
  "lifeCycles": "",
  "forecastAssetTypeLifeCycles": "",
  "addAssetTypeLifeCycle": "",
  "forecastUpdate": "",
  "mandatoryVariants": "",
  "forecast": "",
  "allowBreakLifecycleVariants": "",
  "unlimitedBudget": "",
  "frameworkBudget": "",
  "packageDescription": "",
  "budgetPackages": "",
  "predictiveYear": "",
  "map": "",
  "data": "",
  "Upload": "",
  "attribute": "",
  "value": "",
  "budget": "",
  "budgetYearly": "",
  "percentage": "",
  "inputType": "",
  "inputValue": "",
  "showYearlyBudgetPackages": "",
  "budgetDelete": "",
  "wannaDeleteThisBudget": "",
  "datasetDelete": "",
  "wannaDeleteThisDataset": "",
  "budgetAssetTypes": "",
  "lifeCycle": "",
  "budgetPackage": "",
  "benefitWeight": "",
  "none": "",
  "leading": "",
  "alias": "",
  "headerName": "",
  "infosetAttributes": "",
  "assetAttribute": "",
  "lifeCycleAgeAttribute": "",
  "weightAttribute": "",
  "selectionDetail": "",
  "packages": "",
  "limits": "",
  "filterAttributeName": "",
  "filterSign": "",
  "filterValue": "",
  "limitDetail": "",
  "package": "",
  "selectionLimitPackages": "",
  "years": "",
  "limit": "",
  "totalLimitValue": "",
  "limitValue": "",
  "selectionInfo": "",
  "selectionMethod": "",
  "detail": "",
  "addGroup": "",
  "addPackage": "",
  "addLimit": "",
  "selectionDelete": "",
  "wannaDeleteThisSelection": "",
  "analysisSelection": "",
  "addSelection": "",
  "selectionAreaAssetTypes": "",
  "groupCreate": "",
  "packageLifeCycleViewModel": "",
  "inputMethod": "",
  "packageCreate": "",
  "packageDetail": "",
  "unlimited": "",
  "benefit": "",
  "custom": "",
  "yearly": "",
  "divided": "",
  "limitCreate": "",
  "selectionCreate": "",
  "selectionPackageDelete": "",
  "wannaDeleteThisSelectionPackage": "",
  "selectionLimitDelete": "",
  "wannaDeleteThisSelectionLimit": "",
  "selectionGroupDelete": "",
  "wannaDeleteThisSelectionGroup": "",
  "performanceRangesChart": "",
  "lifeCycleActivitiesChart": "",
  "forecastName": "",
  "selectionName": "",
  "selectionStartYear": "",
  "selectionEndYear": "",
  "createdDate": "",
  "simulation": "",
  "wannaRunSimulation": "",
  "runSimulation": "",
  "export": "",
  "selectionLimitPackageYears": "",
  "benefitSpecification": "",
  "testingSection1": "",
  "testingSection2": "",
  "copy": "",
  "forecastCopy": "",
  "wannaCopyThisForecast": "",
  "validation": "",
  "validate": "",
  "import": "",
  "datasets": "",
  "upload": "",
  "forecasts": "",
  "selections": "",
  "modelingImport": "",
  "areaCreation": "",
  "areaDetail": "",
  "addArea": "",
  "areaCreate": "",
  "area": "",
  "modelingResultDetail": "",
  "limitName": "",
  "conditions": "",
  "spending": "",
  "resultDelete": "",
  "wannaDeleteThisResult": "",
  "modelingResult": "",
  "forecastDelete": "",
  "wannaDeleteThisForecast": "",
  "dependencies": "",
  "cannotDeleteActivity": "",
  "cannotDeleteBenefit": "",
  "cannotDeletePerformance": "",
  "cannotDeleteLifeCycle": "",
  "cannotDeleteDataset": "",
  "cannotDeleteAssetType": "",
  "assetTypeDelete": "",
  "wannaDeleteThisAssetType": "",
  "allDataWillBeLost": "",
  "cannotDeleteSelection": "",
  "loading": "",
  "assetTypeNotEmpty": "",
  "selectionNotEmpty": "",
  "selectionAreaDelete": "",
  "activityUpdated": "",
  "datasetUpdateSucessfull": "",
  "assetTypeUpdated": "",
  "assetTypeInfosetUpdated": "",
  "emptyName": "",
  "benefitUpdated": "",
  "filesUploaded": "",
  "errorWhileUploadingFiles": "",
  "errorWhileUploadingFilesWrongType": "",
  "forecastCopied": "",
  "errorStartEndYearForecast": "",
  "forecastUpdated": "",
  "lifeCycleUpdated": "",
  "missingPerformanceWarning": "",
  "filtersWarning": "",
  "filtersError": "",
  "activitiesError": "",
  "modelingUpdated": "",
  "importSuccess": "",
  "importError": "",
  "lifespanError": "",
  "performanceUpdated": "",
  "selectionGroupCreated": "",
  "selectionGroupError": "",
  "selectionGroupUpdated": "",
  "selectionGroupErrorUpdate": "",
  "selectionLimitCreated": "",
  "selectionLimitError": "",
  "selectionLimitUpdated": "",
  "selectionLimitErrorUpdate": "",
  "limitPackagesMissingValues": "",
  "selectionPackageCreated": "",
  "selectionPackageError": "",
  "selectionPackageUpdated": "",
  "selectionPackageErrorUpdate": "",
  "selectionCreated": "",
  "selectionError": "",
  "selectionUpdated": "",
  "selectionErrorUpdate": "",
  "groupUpdated": "",
  "userUpdated": "",
  "warningAttributeRemoved": "",
  "success": "",
  "error": "",
  "warning": "",
  "resultFailed": "Výpočet selhal",
  "analysisStarted": "Analýza byla úspěšně spuštěna!",
  "modelingResultDeleted": "",
  "wannaDeleteThisModelingResult": "",
  "performanceBefore": "",
  "performanceAfter": ""
}
